import { 
    FETCH_SALE_PROVINCE_PENDING,
    FETCH_SALE_PROVINCE_SUCCESS,
    FETCH_SALE_PROVINCE_FAILURE,
    MAP_FILTER,
    MAP_YEAR_FILTER
} from '../constants/ActionTypes';

let dt = new Date();
let year = dt.getFullYear()

let selectedYear = {value: year - 1, label: year - 1};

const initialState = {
    loader: false,
    saleProvinces: null,
    showMessage: false,
    alertMessage: '',
    filterSelected: { value: "A", label: "ISA_PreviousPeriod" },  // Translate key - resolved in components
    filterYearSelected : selectedYear
}

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SALE_PROVINCE_PENDING:
            return { ...state, loader: true, saleProvinces: null }
        
        case FETCH_SALE_PROVINCE_SUCCESS:
            return { ...state, loader: false, saleProvinces: action.payload }

        case FETCH_SALE_PROVINCE_FAILURE:
            return { ...state, loader: false, showMessage: true, alertMessage: action.payload }

        case MAP_FILTER:
            return { ...state, filterSelected: action.payload }

        case MAP_YEAR_FILTER:
            return { ...state, filterYearSelected: action.payload }
    
        default:
            return { ...state }
    }
}